<aside
  class="fixed flex flex-col px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 transition-all duration-300 ease-in-out z-[102] border-r border-gray-200 xl:top-0 xl:h-screen"
  [ngClass]="{
    'w-[290px]':
      (isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async),
    'w-[90px]': !(
      (isExpanded$ | async) ||
      (isMobileOpen$ | async) ||
      (isHovered$ | async)
    ),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true
  }"
  [ngStyle]="getSidebarStyle()"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="sidebarService.setHovered(false)"
>
  <div
    class="py-6 xl:py-8 flex"
    [ngClass]="{
      'xl:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
      'justify-start': (isExpanded$ | async) || (isHovered$ | async)
    }"
  >
    <a routerLink="/inicio">
      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
      <img
        class="image-logo-general dark:hidden"
        [ngSrc]="imgLogoLight"
        alt="CoreShop"
        width="900"
        height="287"
        priority
      />
      <img
        class="image-logo-general hidden dark:block"
        [ngSrc]="imgLogoDark"
        alt="CoreShop"
        width="900"
        height="287"
        priority
      />
      } @else {
        <img class="image-logo-general" [ngSrc]="imgLogoIcon" alt="CoreShop" width="512" height="512" priority />
      }
    </a>
  </div>

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
    
    <nav class="mb-6">
      <div class="flex flex-col gap-4">
        <!-- NavMenu Section -->
          @for (group of sidebarData?.groups; track group.id) {
            <div>
              <h2
                class="modulo-grupo mb-4 text-xs uppercase flex leading-[20px] text-gray-400"
                [ngClass]="{
                  'xl:justify-center': !(
                    (isExpanded$ | async) || (isHovered$ | async)
                  ),
                  'justify-start': (isExpanded$ | async) || (isHovered$ | async)
                }"
              >
                @if (
                  (isExpanded$ | async) || 
                  (isHovered$ | async) || 
                  (isMobileOpen$ | async)
                ) { 
                  {{group.name}}
                } 
                @else {
                  <svg
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.99915 10.2451C6.96564 10.2451 7.74915 11.0286 7.74915 11.9951V12.0051C7.74915 12.9716 6.96564 13.7551 5.99915 13.7551C5.03265 13.7551 4.24915 12.9716 4.24915 12.0051V11.9951C4.24915 11.0286 5.03265 10.2451 5.99915 10.2451ZM17.9991 10.2451C18.9656 10.2451 19.7491 11.0286 19.7491 11.9951V12.0051C19.7491 12.9716 18.9656 13.7551 17.9991 13.7551C17.0326 13.7551 16.2491 12.9716 16.2491 12.0051V11.9951C16.2491 11.0286 17.0326 10.2451 17.9991 10.2451ZM13.7491 11.9951C13.7491 11.0286 12.9656 10.2451 11.9991 10.2451C11.0326 10.2451 10.2491 11.0286 10.2491 11.9951V12.0051C10.2491 12.9716 11.0326 13.7551 11.9991 13.7551C12.9656 13.7551 13.7491 12.9716 13.7491 12.0051V11.9951Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                }
              </h2>
  
              <ul class="flex flex-col gap-1">
                @for (ctg of group.categories; track ctg.id) {
                  @let categoryId = getCategoryId(group.id, ctg.id);
                  <li>
                    <button
                      (click)="toggleSubmenu(categoryId)"
                      class="menu-item group cursor-pointer"
                      [class.menu-item-active]="openSubmenu === categoryId"
                      [class.menu-item-inactive]="openSubmenu !== categoryId"
                      [ngClass]="{
                        'xl:justify-center': !(
                          (isExpanded$ | async) || (isHovered$ | async)
                        ),
                        'xl:justify-start':
                          (isExpanded$ | async) || (isHovered$ | async)
                      }"
                    >
                      <span
                        class="menu-item-icon-size menu-item-icon-size-system"
                        [class.menu-item-icon-active]="openSubmenu === categoryId"
                        [class.menu-item-icon-inactive]="openSubmenu !== categoryId"
                      >
                      <i [class]="'bi ' + ctg.icon"></i>
                      </span>

                      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                        <span class="menu-item-text"> {{ ctg.name }} </span>
                        @if(group.system){
                          <app-badge variant="light" color="primary"> SYS </app-badge>
                        }
                      }

                      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                        <svg
                          [ngClass]="{
                            'rotate-180 text-brand-500': openSubmenu === categoryId
                          }"
                          width="1em"
                          height="1em"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="ml-auto w-5 h-5 transition-transform duration-200"
                        >
                          <path
                            d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      }
                    </button>

                    <div
                      #subMenu
                      class="overflow-hidden transition-all duration-300"
                      [id]="categoryId"
                      [style.display]="
                        (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                          ? 'block'
                          : 'none'
                      "
                      [ngStyle]="{
                        height:
                          openSubmenu === categoryId
                            ? (subMenuHeights[categoryId] || 0) + 'px'
                            : '0px'
                      }"
                    >
                      <ul class="mt-2 space-y-1 ml-9">
                        @for (mod of ctg.modules; track mod.id) {
                        <li>
                          <a
                            href="#"
                            role="link"
                            (click)="onModuleNavigate(mod.url, $event)"
                            class="menu-dropdown-item"
                            [ngClass]="{
                              'menu-dropdown-item-inactive': !isActive(mod.url),
                              'menu-dropdown-item-active': isActive(mod.url)
                            }"
                          >
                            {{ mod.name }}
                            @if(group.system){
                              <span class="system-identificador-menu">
                                SYS
                              </span>
                            }
                          </a>
                        </li>
                        }
                      </ul>
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        <!-- end NavMenu Section -->
      </div>
    </nav>

  </div>
</aside>
